import { Component, OnInit, Input, ViewEncapsulation, ViewChild, ViewContainerRef } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

export interface CustomModalConfig {
  title: string;
  subtitle?: string;
  body?: string;
  defaultButtonText?: string;
  primaryButtonText?: string;
  isPrimaryButtonVisible?: boolean;
  isCloseCrossVisible?: boolean;
  hasCustomFooter?: boolean;
  type?: string;
  hideHeader?: boolean;
}

@Component({
  selector: 'cm-ngb-custom-modal',
  templateUrl: './ngb-custom-modal.component.html',
  styleUrls: ['./ngb-custom-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class NgbCustomModalComponent implements OnInit {
  @Input()
  set config(config: CustomModalConfig) {
    this.c = {
      ...this.defaultConfig,
      ...config,
    };
  }
  @Input() template;
  @ViewChild('container', { read: ViewContainerRef, static: true })
  container: ViewContainerRef;
  c: CustomModalConfig;
  private defaultConfig = {
    title: '',
    subtitle: '',
    body: '',
    defaultButtonText: 'Close',
    primaryButtonText: 'OK',
    isPrimaryButtonVisible: false,
    hasCustomFooter: false,
    type: 'professional',
    hideHeader: false,
  };

  constructor(private activeModal: NgbActiveModal) {}

  ngOnInit() {
    if (this.template) {
      this.container.insert(this.template.createEmbeddedView(null));
    }
  }

  onPrimaryClick() {
    this.activeModal.close();
  }

  onDefaultClick() {
    this.activeModal.dismiss();
  }

  close() {
    this.activeModal.close();
  }

  dismiss() {
    this.activeModal.dismiss();
  }
}
